/**
 * Formats address object into a comma-separated string.
 * @param {Object} address - Address object with addressLine1, addressLine2, addressLine3, city, county, postCode
 * @returns {string}
 */
export const formatAddress = (address) => {
  if (!address) return "-";
  const parts = [
    address.addressLine1,
    address.addressLine2,
    address.addressLine3,
    address.city,
    address.county,
    address.postCode,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(", ") : "-";
};
